import { Box, Button, Inline, Text } from "@origin-digital/ods-core";
import { IconChevronDownSmall } from "@origin-digital/ods-icons";
import { useUserContext } from "@origin-digital/user-context-provider";
import React, { useState } from "react";
import { IPropertySelection } from "@origin-digital/event-dispatcher";
import { PropertySheet } from "./PropertySheet";
import { trackPropertySelectorOpen } from "./analytics";
import { content } from "./content";

interface IPropertySelectorProps {
  showAllProperties?: boolean;
}

export const PropertySelector: React.FC<IPropertySelectorProps> = () => {
  const { properties, property, setProperty } = useUserContext();

  const [showSheet, setShowSheet] = useState<boolean>(false);

  const activeProperties: IPropertySelection[] = [];
  const inactiveProperties: IPropertySelection[] = [];
  properties?.forEach((prop) =>
    prop.isPrevious
      ? inactiveProperties.push(prop)
      : activeProperties.push(prop)
  );

  if (activeProperties.length > 0) {
    return (
      <Box display="flex" flexDirection="row">
        <Button
          aria-label="Property Selector Button"
          variant="text"
          onClick={() => {
            setShowSheet(true);
          }}
          // Override default tracking to avoid leaking PII
          onClickCapture={() => {
            trackPropertySelectorOpen(properties?.length ?? 0);
          }}
          color="secondaryB"
          size="small"
          data-id="property-selector"
        >
          <Inline alignY="center" space="xsmall" disableWrap={true}>
            <Text
              align="left"
              variant="body-small"
              weight="medium"
              tone="neutral"
              truncate={true}
              inline={true}
            >
              {property?.label.toUpperCase() ?? content.allPropertiesLabel}
            </Text>
            <IconChevronDownSmall
              size="xxxsmall"
              color="neutral"
              variant="solid"
            />
          </Inline>
        </Button>
        <PropertySheet
          selectedProperty={property}
          setProperty={setProperty}
          activeProperties={activeProperties}
          inactiveProperties={inactiveProperties}
          open={showSheet}
          setOpen={setShowSheet}
        />
      </Box>
    );
  }
  return <></>;
};
